import { FormGroup } from "@blueprintjs/core";
import {
  MultiSelectComponent,
  MultiSelectModel,
  SelectEventArgs,
} from "@syncfusion/ej2-react-dropdowns";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import React from "react";
import { FieldLabeledProps, TagsProps } from "../../types/fieldTypes";
import _ from "lodash";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";

export interface TagsFieldProps extends TagsProps {
  labelOnTop?: boolean;
  labelProps?: FieldLabeledProps;
}

export const TagsField: React.FC<TagsFieldProps> = (props) => {
  const tagsRef = React.useRef<MultiSelectComponent | null>(null);
  const [localValue, setLocalValue] = React.useState(props.value);
  const [ready, setReady] = React.useState<boolean>(false);

  React.useEffect(() => {
    setReady(true);

    return () => {
      setReady(false);
      setLocalValue(undefined);
    };
  }, []);

  if (props.hidden) {
    return null;
  }

  // Events
  const handleSelect = async (args: SelectEventArgs) => {
    if (!!tagsRef.current) {
      const allValues = (tagsRef.current.value as string[]) || [];
      allValues.push(args.itemData.text as string);

      //filter out empty strings
      const filteredValues = allValues.filter((value) => value !== "");

      setLocalValue(filteredValues);
      props.onSubmit && props.onSubmit(filteredValues);
    }
  };
  const handleRemoved = async () => {
    if (!!tagsRef.current) {
      const allValues =
        tagsRef.current.value && tagsRef.current.value.length > 0
          ? (tagsRef.current.value as string[])
          : undefined;

      setLocalValue(allValues);
      props.onSubmit && props.onSubmit(allValues);
    }
  };

  const defaultTagsSettings: MultiSelectModel & DefaultHtmlAttributes = {
    allowCustomValue: true,
    // Immutable
    select: handleSelect,
    removed: handleRemoved,
    addTagOnBlur: true,
    openOnClick: false,
  };

  return (
    <FormGroup
      className={`${
        (props.isRequired && !localValue) ||
        (props.isRequired &&
          (localValue === null ||
            localValue === undefined ||
            localValue.length === 0))
          ? "has-required-background"
          : "tags-field"
      }`}
    >
      {props.label && (
        <FieldLabel
          labelName={props.label}
          tooltipDescription={props.description}
          fieldProps={{ ...props, value: localValue }}
          isRequired={props.isRequired}
          {...props.labelProps}
        />
      )}
      {ready && (
        <div className="tags-toolbar">
          {ready && (
            <div
              className={`${
                props.disabled
                  ? "tags-input-container__readonly"
                  : "tags-input-container"
              }`}
            >
              {/* No datasource since its for tags purpose */}
              <MultiSelectComponent
                ref={tagsRef}
                id="tags-search-list"
                className="tags-input"
                readonly={props.disabled}
                placeholder={props.placeholder}
                {...({
                  ...defaultTagsSettings,
                  ...(props.tagsSettings || {}),
                  value: localValue,
                } as MultiSelectModel & DefaultHtmlAttributes)}
              />
            </div>
          )}
        </div>
      )}
      {props.errorMessages && (
        <>
          {props.errorMessages.map((errorMessage, idx) => (
            <p key={idx} className="error-message">
              {errorMessage}
            </p>
          ))}
        </>
      )}
    </FormGroup>
  );
};
